import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesByFiscalNumberComponent from './sales-by-fiscal-number.component';

let SalesByFiscalNumberModule = angular
  .module('SalesByFiscalNumber', [
    uiRouter
  ])
  .component('salesbyfiscalnumber', SalesByFiscalNumberComponent)
  .filter('ncfType', ($translate) => {
    "ngInject";
    const _ = $translate.instant 
    return (token) => {
      const ncfTypes = {
        '01': _('Crédito fiscal'),
        '02': _('Consumidor Final'),
        '03': _('Notas de Débito'),
        '04': _('Notas de Crédito'),
        '14': _('Regimen Especial'),
        '15': _('Gubernamental'),
      }
      return ncfTypes[token];
    }
  })
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesByFiscalNumber', {
      url: '/sales-by-ncf',
      data: {
        authRequired: true,
        permsRequired: ['sales-by-ncf']
      },
      views: {
        'menu': 'menu',
        'content': {
          'component': 'salesbyfiscalnumber'
        }
      }
    })
  })
  .name;

export default SalesByFiscalNumberModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-fiscal-number/sales-by-fiscal-number.module.js